/**
 * IBAS brand constants — sourced verbatim from the 2026 Brand Guidelines and the
 * consolidated rebuild brief. Keep this as the single source of truth for
 * institutional naming, messaging and colour values used in TS (the same colour
 * values are mirrored as CSS tokens in src/styles/index.css).
 */

export const brand = {
  legalName: 'International Business Academy of Switzerland',
  shortName: 'IBAS',
  established: 2013,

  essence: 'Accessible Swiss quality for global career growth.',
  institutionalTagline: 'Quality Education. Affordable and Accessible for All.',
  campaignLine: 'Study Your Way. Connect Globally.',
  supportingPhrase: 'Graduate with Swiss Quality',
  promise: ['Study flexibly.', 'Develop practical capability.', 'Progress globally.'],

  /** Programme framework: FLEXI (flexible design) / EDU (applied depth) / CARE (support). */
  framework: [
    { key: 'FLEXI', label: 'Flexible design' },
    { key: 'EDU', label: 'Applied academic depth' },
    { key: 'CARE', label: 'Support across the journey' },
  ],
} as const;

/** Colour tokens (HEX). Mirrors the CSS custom properties in index.css. */
export const brandColors = {
  primaryNavy: '#150E42',
  secondaryNavy: '#1D1A57',
  primaryGold: '#C69214',
  lightGold: '#DDB246',
  logoNavy: '#0E2653',
  logoGold: '#D6B14A',
  white: '#FFFFFF',
  lightGrey: '#F5F5F5',
  mediumGrey: '#6B6B6B',
  darkText: '#2B2B2B',
} as const;

export type BrandColorToken = keyof typeof brandColors;
